module.exports = __webpack_public_path__ + "img/d9fdf5e8ea899511244yy656c9f6ca6e.fcdf5fda.png";